export const EMAIL_TEMPLATE_FIELDS = {
  // TODO: Change to fields that BE provide
  name: "Agency Name",
  company: "Agency Company",
  email: "Agency Email",
  phone: "Agency Phone",
};
